import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import tripDuck from 'ducks/trip-duck';
import Faqs from '../components/faq/faqs';
import css from './faq-view.less';
import Header from '../components/header/header';
import { getFaqsStringsFromKeyList } from '../common/utils/data-utils';
import {
  sendGAFaqEvent,
  FaqClickEventDataCreator,
} from '../common/utils/google-analytics-helper';
import { GA_EVENT_FAQ_INGRESS } from '../constants/google-analytics';

const FaqView = () => {
  const tripData = useSelector(tripDuck.selectors.trip);

  useEffect(() => {
    const event = tripData.status || null;
    sendGAFaqEvent(
      FaqClickEventDataCreator(
        event,
        GA_EVENT_FAQ_INGRESS,
        tripData.orderId,
        null,
        null,
      ),
    );
  }, []);

  return (
    <div className={css.content}>
      <Header />
      <Faqs
        items={getFaqsStringsFromKeyList()}
        currentStatus={tripData.status}
        orderID={tripData.orderId}
      />
    </div>
  );
};

export default FaqView;
